"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryDropItem = exports.isWalkable = exports.do_use = exports.nx_use = exports.do_drop = exports.nx_drop = exports.do_pickup = exports.nx_pickUp = exports.do_open = exports.nx_open = exports.do_smash = exports.nx_smash = exports.renderAt = exports.updateTickAll = exports.updateAll = exports.removeDead = exports.killAll = exports.kill = exports.getByIdSafe = exports.getAtIIJ = exports.getAtIJ = exports.setTile = exports.moveToIJ = exports.create = exports.getAll = void 0;
var diveAstar_1 = require("@dive/astar/diveAstar");
var diveAstar_sidecar_1 = require("@dive/astar/diveAstar-sidecar");
var diveColors_1 = require("@dive/colors/diveColors");
var diveDebug_sidecar_1 = require("@dive/debug/diveDebug-sidecar");
var diveParticles_sidecar_1 = require("@dive/effects/diveParticles-sidecar");
var diveSlashEffect_1 = require("@dive/effects/diveSlashEffect");
var diveSlashEffect_sidecar_1 = require("@dive/effects/diveSlashEffect-sidecar");
var diveSimulationManager_sidecar_1 = require("@dive/simulation/diveSimulationManager-sidecar");
var spritesCrew_1 = require("@dive/spriteRecyclers/spritesCrew");
var diveTilemap_sidecar_1 = require("@dive/tilemap/diveTilemap-sidecar");
var diveTilemapUtils_sidecar_1 = require("@dive/tilemap/diveTilemapUtils-sidecar");
var arrayUtils_sidecar_1 = require("@engine/arrayUtils-sidecar");
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var distanceUtil_sidecar_1 = require("@lib/distanceUtil-sidecar");
var imports_1 = require("@lib/imports");
var common_sidecar_1 = require("@main/common-sidecar");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var diveCrew_hero_1 = require("@voyage/crew/diveCrew_hero");
var diveCrew_hero_data_1 = require("@voyage/crew/diveCrew_hero_data");
var diveCrew_hero_misc_sidecar_1 = require("@voyage/crew/diveCrew_hero_misc-sidecar");
var diveCrew_misc_sidecar_1 = require("@voyage/crew/diveCrew_misc-sidecar");
var diveCrew_movable_sidecar_1 = require("@voyage/crew/diveCrew_movable-sidecar");
var voyageMessageCrewHurt_1 = require("@voyage/multi/voyageMessageCrewHurt");
var diveObjects_sidecar_1 = require("./diveObjects-sidecar");
var diveObjectsData_1 = require("./diveObjectsData");
var diveObjectsData_sidecar_1 = require("./diveObjectsData-sidecar");
var namespace = 'dive-objects';
var objs = [];
function getAll() {
    return objs;
}
exports.getAll = getAll;
function create(id, data) {
    id = diveSimulationManager_sidecar_1.diveSimulationManager.synced_createId(id);
    var obj = {
        id: id,
        idLoaded: -1,
        isDead: false,
        eType: 'voy-misc',
        data: data,
        i: -1,
        j: -1,
        isOpen: false,
        isPickedUp: false,
        tile: null,
        ability1Uses: data.maxAbility1Uses,
        ability2Uses: data.maxAbility2Uses,
        isAwake: false,
        ticksAwake: 0,
        flickerTimer: 0,
        flickerState: 0,
    };
    objs.push(obj);
    return obj;
}
exports.create = create;
function moveToIJ(obj, i, j) {
    var gs = diveTilemap_sidecar_1.diveTilemap.getSafe(i, j);
    setTile(obj, gs);
}
exports.moveToIJ = moveToIJ;
function setTile(obj, tile) {
    if (tile === obj.tile) {
        // Allready set
        return;
    }
    // Remove from current
    if (obj.tile) {
        arrayUtils_sidecar_1.arrayUtils.remove(obj.tile.objects, obj);
    }
    // Add to new
    obj.tile = tile;
    if (obj.tile) {
        arrayUtils_sidecar_1.arrayUtils.addIfNew(obj.tile.objects, obj);
        obj.i = obj.tile.i;
        obj.j = obj.tile.j;
    }
    if (!tile) {
        obj.i = -1;
        obj.j = -1;
    }
}
exports.setTile = setTile;
// export function getAllAtIJ(
//   i: number,
//   j: number,
//   filter: ((c: IDiveObject) => boolean) | null = null,
// ) {
//   return objs.filter((c) => {
//     return (
//       !c.isDead &&
//       !c.isPickedUp &&
//       i === c.i &&
//       j === c.j &&
//       (!filter || filter(c))
//     )
//   })
// }
function getAtIJ(i, j, filter) {
    if (filter === void 0) { filter = null; }
    for (var idx = 0; idx < objs.length; idx++) {
        var c = objs[idx];
        if (c.isDead) {
            continue;
        }
        if (c.isPickedUp) {
            continue;
        }
        if (i === c.i && j === c.j) {
            if (!filter || filter(c)) {
                return c;
            }
        }
    }
    return null;
}
exports.getAtIJ = getAtIJ;
function getAtIIJ(iij, filter) {
    if (filter === void 0) { filter = null; }
    return getAtIJ(iij.i, iij.j, filter);
}
exports.getAtIIJ = getAtIIJ;
function getByIdSafe(id) {
    return entitiesUtils_sidecar_1.entitiesUtils.findByIdSafe(id, objs);
}
exports.getByIdSafe = getByIdSafe;
function kill(obj) {
    obj.isDead = true;
    setTile(obj, null);
}
exports.kill = kill;
function killAll() {
    imports_1.l.forEach(objs, function (c) {
        kill(c);
    });
    removeDead();
}
exports.killAll = killAll;
function removeDead() {
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) { });
}
exports.removeDead = removeDead;
function updateAll() {
    imports_1.l.forEach(objs, function (c) {
        update(c);
    });
}
exports.updateAll = updateAll;
function updateTickAll() {
    imports_1.l.forEach(objs, function (c) {
        updateTick(c);
    });
    removeDead();
}
exports.updateTickAll = updateTickAll;
function update(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    // console.log('update obj', obj)
    if (obj.isDead) {
        return;
    }
    if (obj.isPickedUp) {
        return; // Don't render, in inventory
    }
    var recycler = spritesCrew_1.spritesCrew;
    var _a = diveTilemap_sidecar_1.diveTilemap.convertIIJtoXY(obj), x = _a.x, y = _a.y;
    renderAt(obj, spritesCrew_1.spritesCrew, x, y);
    // TODO: do something with objects
    // TODO: pathfinding
}
function renderAt(obj, recycler, x, y) {
    var frameNum = 0;
    if (obj.isOpen) {
        frameNum = 1;
    }
    var visibility = diveTilemapUtils_sidecar_1.diveTilemapUtils.getSpotVisiblityIIJ(obj);
    if (visibility === 0) {
        return;
    }
    var alpha = 1;
    if (visibility === 1) {
        alpha = 0.5;
    }
    var img = recycler.getNext(x, y, obj.data.frames[frameNum]);
    img.alpha = alpha;
    if (obj.data.key === diveObjectsData_1.EDiveObjectType.Firepit) {
        // TODO: move to updateTick?
        if (visibility === 2) {
            var es = common_sidecar_1.common.getUpdateDeltaScaled();
            obj.flickerTimer -= es;
            if (obj.flickerTimer <= 0) {
                var unsyncedRando = diveSimulationManager_sidecar_1.diveSimulationManager.getUUnsyncedUnimportantRando();
                obj.flickerTimer = unsyncedRando.f(0.05, 0.25);
                obj.flickerState = unsyncedRando.i(0, 1);
            }
        }
        // Flip
        img.scaleX *= obj.flickerState ? 1 : -1;
        // console.log('test scaleX', obj.flickerState)
    }
    // Potions
    if (obj.data.isDualColor) {
        img.tint = obj.data.tint;
        var img2 = recycler.getNext(x, y, obj.data.frames[frameNum + 1]);
        img2.alpha = alpha;
    }
}
exports.renderAt = renderAt;
function updateTick(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    if (obj.isDead) {
        return;
    }
    if (obj.isPickedUp) {
        return;
    }
    if (obj.data.specialEffect === diveObjectsData_1.EDiveObjectSpecialEffect.None) {
        return;
    }
    if (obj.data.specialEffect === diveObjectsData_1.EDiveObjectSpecialEffect.TurnIntoSpider) {
        var tile = obj.tile;
        if (tile) {
            if (diveTilemapUtils_sidecar_1.diveTilemapUtils.wasSpotVisibleToHero(tile)) {
                obj.isAwake = true;
            }
            if (obj.isAwake) {
                obj.ticksAwake += 1;
            }
            // TODO: make this random?
            if (obj.ticksAwake > 15 * 10) {
                do_smash(obj);
                // Spawn a spider here
                var mons = diveCrew_sidecar_1.diveCrew.create(diveCrew_1.EVoyageCrewType.Enemy, diveCrew_hero_data_1.EDiveHeroSubtype.None, 'spider-mini', 0, 0);
                diveCrew_sidecar_1.diveCrew.moveToIIJ(mons, tile);
                if (diveTilemapUtils_sidecar_1.diveTilemapUtils.isSpotVisibleToHero(tile)) {
                    diveParticles_sidecar_1.diveParticles.createMultiple('poof', mons.x, mons.y, 3, diveColors_1.diveColors.pureWhite);
                }
            }
        }
    }
    if (obj.data.specialEffect === diveObjectsData_1.EDiveObjectSpecialEffect.WebStun) {
        // Do we have a hero here?
        if (obj.tile) {
            if (obj.tile.crew.length > 0) {
                for (var iCrew = 0; iCrew < obj.tile.crew.length; iCrew++) {
                    var crew = obj.tile.crew[iCrew];
                    if (crew.heroType !== diveCrew_hero_data_1.EDiveHeroSubtype.None) {
                        // Stun this hero
                        diveCrew_misc_sidecar_1.diveCrew_misc.stun(crew, 5 * 10);
                        kill(obj);
                        return;
                    }
                }
            }
        }
    }
}
function nx_smash(msg) {
    var mons = diveCrew_sidecar_1.diveCrew.findById(msg.targetId);
    if (!mons || !mons.heroState) {
        return;
    }
    // Is there an object here?
    var dungeonObj = getAtIJ(msg.tx, msg.ty);
    if (!dungeonObj) {
        return;
    }
    // Are we next to the target?
    if (distanceUtil_sidecar_1.distanceUtil.isNextTo4_IIJ_IJ(mons, msg.tx, msg.ty)) {
        do_smash(dungeonObj);
    }
    else {
        // Move to the target
        var path = diveCrew_movable_sidecar_1.diveCrew_movable.sync_tryPathTo(mons, msg.tx, msg.ty, diveAstar_1.EDivePathToMode.NextTo, true);
        diveCrew_movable_sidecar_1.diveCrew_movable.setNewPath(mons, path);
        // Add this as an after move action
        mons.heroState.afterMove_action = diveCrew_hero_1.EDiveAfterMoveAction.Smash;
        mons.heroState.afterMove_target_i = msg.tx;
        mons.heroState.afterMove_target_j = msg.ty;
        mons.heroState.afterMove_target_id = dungeonObj.id;
    }
}
exports.nx_smash = nx_smash;
function do_smash(obj) {
    var i = obj.i;
    var j = obj.j;
    var data = obj.data;
    tryDropItemsFrom(obj, true); // Object will be dead
    if (data.smashInto) {
        var dataSmashInto = diveObjectsData_sidecar_1.diveObjectsData.find(data.smashInto);
        if (dataSmashInto) {
            var newObj = create(0, dataSmashInto);
            moveToIJ(newObj, i, j);
            var effect = diveSlashEffect_sidecar_1.diveSlashEffect.create(diveSlashEffect_1.EDiveSlashEffect.Slash);
            diveSlashEffect_sidecar_1.diveSlashEffect.moveToIIJ(effect, newObj);
            return newObj;
        }
    }
    return null;
}
exports.do_smash = do_smash;
function tryDropItemsFrom(obj, doKill) {
    var ti = obj.i;
    var tj = obj.j;
    var data = obj.data;
    if (doKill) {
        kill(obj);
    }
    var dropChance = data.dropChance + diveDebug_sidecar_1.diveDebug.debug_extraDropChance;
    if (dropChance) {
        console.log('getSyncedImportantRando', 'tryDropItemsFrom');
        var rnd = diveSimulationManager_sidecar_1.diveSimulationManager.getSyncedImportantRando();
        if (rnd.chance(dropChance)) {
            var numDrops = rnd.i(data.minDrops, data.maxDrops);
            numDrops += diveDebug_sidecar_1.diveDebug.debug_dropNumExtraItems; // debug
            for (var i = 0; i < numDrops; i++) {
                var datas = [
                    diveObjectsData_1.EDiveObjectType.GoldPile,
                    diveObjectsData_1.EDiveObjectType.Key1,
                    // EDiveObjectType.Key2,
                    diveObjectsData_1.EDiveObjectType.Potion1,
                    diveObjectsData_1.EDiveObjectType.Potion2,
                    diveObjectsData_1.EDiveObjectType.Weapon_Sword,
                    diveObjectsData_1.EDiveObjectType.Weapon_Spellbook,
                    diveObjectsData_1.EDiveObjectType.Weapon_Bow,
                    diveObjectsData_1.EDiveObjectType.Scroll,
                ];
                var newType = rnd.sample(datas);
                if (newType) {
                    var newTypeData = diveObjectsData_sidecar_1.diveObjectsData.find(newType);
                    assert_sidecar_1.assert.notNil(newTypeData);
                    var newObj = diveObjects_sidecar_1.diveObjects.create(0, newTypeData);
                    console.log('try to drop', newType);
                    tryDropItem(newObj, ti, tj, true, false);
                }
            }
        }
    }
}
function nx_open(msg) {
    var mons = diveCrew_sidecar_1.diveCrew.findById(msg.targetId);
    if (!mons || !mons.heroState) {
        return;
    }
    // Is there an object here?
    var dungeonObj = getAtIJ(msg.tx, msg.ty);
    if (!dungeonObj) {
        return;
    }
    // Are we next to the target?
    if (distanceUtil_sidecar_1.distanceUtil.isNextTo4_IIJ_IJ(mons, msg.tx, msg.ty)) {
        do_open(dungeonObj);
    }
    else {
        // Move to the target
        var path = diveCrew_movable_sidecar_1.diveCrew_movable.sync_tryPathTo(mons, msg.tx, msg.ty, diveAstar_1.EDivePathToMode.NextTo, true);
        diveCrew_movable_sidecar_1.diveCrew_movable.setNewPath(mons, path);
        // Add this as an after move action
        mons.heroState.afterMove_action = diveCrew_hero_1.EDiveAfterMoveAction.Open;
        mons.heroState.afterMove_target_i = msg.tx;
        mons.heroState.afterMove_target_j = msg.ty;
        mons.heroState.afterMove_target_id = dungeonObj.id;
    }
}
exports.nx_open = nx_open;
function do_open(obj) {
    if (obj.data.canOpen && !obj.isOpen) {
        obj.isOpen = true;
        tryDropItemsFrom(obj, false);
    }
}
exports.do_open = do_open;
function nx_pickUp(msg) {
    var mons = diveCrew_sidecar_1.diveCrew.findById(msg.fromCrewId);
    if (!mons || !mons.heroState) {
        console.warn('no mons for pickup');
        return;
    }
    // Is there an object here?
    var dungeonObj = getByIdSafe(msg.targetId);
    //let dungeonObj = getAtIJ(msg.tx, msg.ty)
    if (!dungeonObj) {
        console.warn('no dungeonObj for pickup');
        return;
    }
    // Are we next to the target?
    if (distanceUtil_sidecar_1.distanceUtil.isAt(mons.i, mons.j, msg.tx, msg.ty)) {
        do_pickup(mons, dungeonObj);
    }
    else {
        // Move to the target
        var path = diveCrew_movable_sidecar_1.diveCrew_movable.sync_tryPathTo(mons, msg.tx, msg.ty, diveAstar_1.EDivePathToMode.On, true);
        diveCrew_movable_sidecar_1.diveCrew_movable.setNewPath(mons, path);
        // Add this as an after move action
        mons.heroState.afterMove_action = diveCrew_hero_1.EDiveAfterMoveAction.PickUp;
        mons.heroState.afterMove_target_i = dungeonObj.i;
        mons.heroState.afterMove_target_j = dungeonObj.j;
        mons.heroState.afterMove_target_id = dungeonObj.id;
    }
}
exports.nx_pickUp = nx_pickUp;
function do_pickup(mons, obj, animateClassChange) {
    if (animateClassChange === void 0) { animateClassChange = true; }
    // TODO: loot vs item slot
    if (obj.data.canBePickedUp && !obj.isPickedUp) {
        // Mark this object as picked up so we can drop here
        obj.isPickedUp = true;
        // Pickup this object
        if (obj.data.equipSlot === diveObjectsData_1.EDiveEquipSlot.Weapon) {
            if (mons.weaponSlot) {
                do_drop(mons, mons.weaponSlot, obj.data.equipSlot, false);
            }
            mons.weaponSlot = obj;
            diveCrew_hero_misc_sidecar_1.diveCrew_hero_misc.changeHeroClass(mons, obj.data.heroClass, animateClassChange);
        }
        if (obj.data.equipSlot === diveObjectsData_1.EDiveEquipSlot.Item) {
            if (mons.itemSlot1) {
                do_drop(mons, mons.itemSlot1, obj.data.equipSlot);
            }
            mons.itemSlot1 = obj;
        }
        if (obj.data.equipSlot === diveObjectsData_1.EDiveEquipSlot.Loot) {
            if (mons.lootSlot1) {
                do_drop(mons, mons.lootSlot1, obj.data.equipSlot);
            }
            mons.lootSlot1 = obj;
        }
    }
}
exports.do_pickup = do_pickup;
function nx_drop(msg, equipSlot, animateClassChange) {
    if (animateClassChange === void 0) { animateClassChange = true; }
    var mons = diveCrew_sidecar_1.diveCrew.findById(msg.targetId);
    if (!mons || !mons.heroState) {
        return false;
    }
    // Can drop on other objects with new algo
    // let dungeonObjHere = getAtIJ(mons.i, mons.j)
    // if (dungeonObjHere) {
    //   // TODO: swap items?
    //   return false // No space!
    // }
    // TODO: clean this up better?
    if (equipSlot === diveObjectsData_1.EDiveEquipSlot.Item) {
        if (!mons.itemSlot1) {
            return false;
        }
        do_drop(mons, mons.itemSlot1, equipSlot);
    }
    if (equipSlot === diveObjectsData_1.EDiveEquipSlot.Loot) {
        if (!mons.lootSlot1) {
            return false;
        }
        do_drop(mons, mons.lootSlot1, equipSlot);
    }
    if (equipSlot === diveObjectsData_1.EDiveEquipSlot.Weapon) {
        if (!mons.weaponSlot) {
            return false;
        }
        do_drop(mons, mons.weaponSlot, equipSlot, animateClassChange);
    }
    return true;
}
exports.nx_drop = nx_drop;
function do_drop(mons, obj, equipSlot, animateClassChange, forced) {
    if (animateClassChange === void 0) { animateClassChange = true; }
    if (forced === void 0) { forced = false; }
    // TODO: clean this up better?
    if (equipSlot === diveObjectsData_1.EDiveEquipSlot.Item) {
        if (mons.itemSlot1 && mons.itemSlot1 === obj) {
            // Drop this item
            if (tryDropItem(obj, mons.i, mons.j, forced, !forced)) {
                mons.itemSlot1 = null;
            }
        }
    }
    if (equipSlot === diveObjectsData_1.EDiveEquipSlot.Loot) {
        if (mons.lootSlot1 && mons.lootSlot1 === obj) {
            // Drop this item
            if (tryDropItem(obj, mons.i, mons.j, forced, !forced)) {
                mons.lootSlot1 = null;
            }
        }
    }
    if (equipSlot === diveObjectsData_1.EDiveEquipSlot.Weapon) {
        if (mons.weaponSlot && mons.weaponSlot === obj) {
            // Drop this item
            if (tryDropItem(obj, mons.i, mons.j, forced, !forced)) {
                mons.weaponSlot = null;
                // Revert to peasant
                diveCrew_hero_misc_sidecar_1.diveCrew_hero_misc.changeHeroClass(mons, diveCrew_hero_data_1.EDiveHeroSubtype.Peasant, animateClassChange);
            }
        }
    }
}
exports.do_drop = do_drop;
function nx_use(msg, equipSlot) {
    var mons = diveCrew_sidecar_1.diveCrew.findById(msg.targetId);
    if (!mons || !mons.heroState) {
        console.log(namespace, 'no mons for use');
        return false;
    }
    if (equipSlot === diveObjectsData_1.EDiveEquipSlot.Item) {
        if (!mons.itemSlot1) {
            console.log(namespace, 'no item slot for use');
            return false;
        }
        do_use(mons, mons.itemSlot1, equipSlot);
        return true;
    }
    console.log(namespace, 'nothing for use');
    return false;
}
exports.nx_use = nx_use;
function do_use(mons, obj, equipSlot) {
    // TODO: clean this up better?
    if (equipSlot === diveObjectsData_1.EDiveEquipSlot.Item) {
        if (mons.itemSlot1 && mons.itemSlot1 === obj) {
            // TODO: move elsewhere
            var animate = true;
            var color = diveColors_1.diveColors.pureWhite;
            if (obj.data.key === diveObjectsData_1.EDiveObjectType.Potion1) {
                color = diveColors_1.diveColors.red;
                // Heal
                diveCrew_sidecar_1.diveCrew.hurt(mons, -100, voyageMessageCrewHurt_1.EVoyageCrewDamageType.Heal, mons.id);
            }
            if (obj.data.key === diveObjectsData_1.EDiveObjectType.Potion2) {
                color = diveColors_1.diveColors.blueGray;
                // Restore mana / spell uses
                if (mons.weaponSlot) {
                    mons.weaponSlot.ability1Uses = mons.weaponSlot.data.maxAbility1Uses;
                    mons.weaponSlot.ability2Uses = mons.weaponSlot.data.maxAbility2Uses;
                }
            }
            if (animate) {
                // TODO: *poof* effect
                diveParticles_sidecar_1.diveParticles.createMultiple('poof', mons.x, mons.y, 5, color);
            }
            diveObjects_sidecar_1.diveObjects.kill(obj);
            mons.itemSlot1 = null;
            // // Drop this item
            // let drop = mons.itemSlot1
            // mons.itemSlot1 = null
            // drop.isPickedUp = false
            // moveToIJ(drop, mons.i, mons.j)
        }
    }
}
exports.do_use = do_use;
function isWalkable(obj) {
    if (obj.data.canBeWalkedOn) {
        return true;
    }
    if (obj.data.canBeWalkedOnIfOpen && obj.isOpen) {
        return true;
    }
    return false;
}
exports.isWalkable = isWalkable;
function tryDropItem(obj, i, j, killOnFail, requireVisibility) {
    var e_1, _a;
    if (!obj.data.canBePickedUp) {
        assert_sidecar_1.assert.failed('cannot drop this item, it cant be picked up!', obj.data.type);
    }
    var layers = [
        [[0, 0]],
        [
            [1, 0],
            [0, 1],
            [-1, 0],
            [0, -1],
        ],
        [
            [1, 1],
            [-1, 1],
            [-1, -1],
            [1, -1],
        ],
        [
            [2, 0],
            [0, 2],
            [-2, 0],
            [0, -2],
        ],
        [
            [2, 1],
            [1, 2],
            [-1, 2],
            [-2, 1],
            [-2, -1],
            [-1, -2],
            [1, -2],
            [2, -1],
        ],
        [
            [2, 2],
            [-2, 2],
            [-2, -2],
            [2, -2],
        ], // 5
    ];
    for (var iLayers = 0; iLayers < layers.length; iLayers++) {
        var layer = layers[iLayers];
        // Randomize our drop directions
        console.log('tryDropItem', 'tryDropItemsFrom');
        diveSimulationManager_sidecar_1.diveSimulationManager.getSyncedImportantRando().shuffle(layer);
        for (var iOffsets = 0; iOffsets < layer.length; iOffsets++) {
            var offsets = layer[iOffsets];
            var ti = i + offsets[0];
            var tj = j + offsets[1];
            var gs = diveTilemap_sidecar_1.diveTilemap.getSafe(ti, tj);
            if (!gs) {
                // console.log('skip drop, no tile here', ti, tj)
                continue;
            }
            if (!diveAstar_sidecar_1.diveAstar.canWalkTile(gs)) {
                // console.log('skip drop, cannot walk here', ti, tj)
                continue;
            }
            if (requireVisibility) {
                if (!diveTilemapUtils_sidecar_1.diveTilemapUtils.isSpotVisibleToHero(gs)) {
                    // console.log('skip drop, not visible here', ti, tj)
                    continue;
                }
            }
            var objsHere = gs.objects; //  getAllAtIJ(ti, tj) // TODO: more efficient check for this?
            var alreadyHasItem = false;
            try {
                for (var objsHere_1 = (e_1 = void 0, __values(objsHere)), objsHere_1_1 = objsHere_1.next(); !objsHere_1_1.done; objsHere_1_1 = objsHere_1.next()) {
                    var objHere = objsHere_1_1.value;
                    // if (objHere === allowOn) {
                    //   continue
                    // }
                    // console.log('objHere', objHere)
                    if (objHere.data.canBePickedUp) {
                        alreadyHasItem = true;
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (objsHere_1_1 && !objsHere_1_1.done && (_a = objsHere_1.return)) _a.call(objsHere_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            if (alreadyHasItem) {
                // console.log('skip drop, already has item here', ti, tj)
                continue;
            }
            // if (diveObjects.getAtIJ(ti, tj)) {
            //   continue
            // }
            // Ok this is a fine spot
            diveObjects_sidecar_1.diveObjects.moveToIJ(obj, ti, tj);
            obj.isPickedUp = false;
            return true;
        }
    }
    if (killOnFail) {
        kill(obj);
    }
    return false;
}
exports.tryDropItem = tryDropItem;
